/**
 * Copy text to the clipboard, with a fallback for the browsers and contexts where
 * `navigator.clipboard` is unavailable (notably non-HTTPS origins and older Safari).
 *
 * Extracted from UpcomingListingsPage, which used it for the calendar feed URL, so
 * the external-booking payment link can reuse it instead of a second copy.
 *
 * @param {string} text
 * @returns {Promise<boolean>} whether the copy succeeded
 */
export function copyTextToClipboard(text) {
  if (typeof text !== 'string' || !text) {
    return Promise.resolve(false);
  }
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard
      .writeText(text)
      .then(() => true)
      .catch(() => copyTextToClipboardFallback(text));
  }
  return Promise.resolve(copyTextToClipboardFallback(text));
}

function copyTextToClipboardFallback(text) {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  ta.style.top = '0';
  document.body.appendChild(ta);
  ta.focus();
  ta.select();
  try {
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    document.body.removeChild(ta);
    return false;
  }
}
